const branchConfig = (branch = {}, action) => {
  switch (action.type) {
    case 'GET_BRANCH':
      return action.playload;
    default:
      return branch;
  }
};
export default branchConfig;
